import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { modalId: String };

  connect() {
    this.helperElement = this.element.querySelector('[data-input-target="helper"]');
    this.wrapperElement = this.element.querySelector('[data-input-target="wrapper"]');

    if (this.helperElement) {
      this.helperElement.classList.add('hidden');
    }
  }

  save(event) {
    event.preventDefault();
    event.stopPropagation();

    const rawValue = (this.element.querySelector('input[name="revised_fixed_fee"]')?.value || "").trim();
    const amount = rawValue.replace(/,/g, '');

    if (!amount || parseFloat(amount) <= 0) {
      this._showValidationError();
      return;
    }

    this._hideValidationError();

    window.dispatchEvent(new CustomEvent("revised-fixed-fee:confirm", {
      detail: { amount }
    }));

    const input = this.element.querySelector('input[name="revised_fixed_fee"]');
    if (input) input.value = '';

    this._closeModal();
  }

  _showValidationError() {
    if (this.helperElement) {
      this.helperElement.classList.remove('hidden');
      this.helperElement.classList.add('text-red-1000');
    }
    if (this.wrapperElement) {
      this.wrapperElement.classList.add('has-error');
    }
  }

  _hideValidationError() {
    if (this.helperElement) {
      this.helperElement.classList.add('hidden');
      this.helperElement.classList.remove('text-red-1000');
    }
    if (this.wrapperElement) {
      this.wrapperElement.classList.remove('has-error');
    }
  }

  cancel(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    const input = this.element.querySelector('input[name="revised_fixed_fee"]');
    if (input) input.value = '';

    this._hideValidationError();

    window.dispatchEvent(new CustomEvent("revised-fixed-fee:cancel"));
    this._closeModal();
  }

  closeIfBackdrop(event) {
    if (event.target.id === 'revised-fixed-fee-modal') {
      this.cancel();
    }
  }

  _closeModal() {
    const modal = document.getElementById('revised-fixed-fee-modal');
    if (modal) {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
    }
  }
}
